<template>
    <div class="live-list-section">
        <!-- 4直播 -->
        <van-row @click="go_live_detail(dataItem.content, dataItem)">
            <div class="live-list-section-box">
                <div class="live-list-section-left">
                    <img class="live-list-section-left-img" :src="dataItem.content.cover_img" />
                    <div class="live-list-section-left-top" v-if="dataItem.top == 1">
                        <img src="/static/bytx/tag_top.svg" alt="" />
                    </div>
                    <div v-else-if="dataItem.content.type == 2" class="live-list-section-left-zl">
                        直播专栏
                    </div>
                    <div v-else-if="dataItem.content.live_status == 0" class="live-list-section-left-zl">
                        预告
                    </div>
                    <div v-else-if="dataItem.content.live_status == 1" class="live-list-section-left-zl">
                        <img src="/static/bytx/activity_list_live_icon.gif" alt="" /> 直播中
                    </div>
                    <div v-else class="live-list-section-left-zl">
                        回放
                    </div>
                    <div class="live-list-section-left-time" v-if="dataItem.content.live_status > 1">
                        <span>{{ dataItem.content.duration_format }}</span>
                    </div>
                </div>
                <div class="live-list-section-right">
                    <div class="live-list-section-right-title" v-html="dataItem.content.title"></div>
                    <div class="live-list-section-right-detail" style="bottom: 0">
                        <span v-if="dataItem.content.type === 2">共{{ dataItem.content.total_count }}期</span>
                        <span v-else-if="dataItem.content.live_status < 2">{{ dataItem.content.start_at }}</span>
                        <span v-else>{{ dataItem.content.view_count }}人观看</span>
                        <span
                            class="live-list-section-right-detail-join"
                            v-if="dataItem.content.type === 1 && dataItem.live_status < 2"
                        >
                            <span>{{
                                dataItem.live_status === 0 ? (dataItem.isAppointment ? '已预约' : '预约') : '加入'
                            }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </van-row>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },

    methods: {
        go_live_detail(item, i) {
            Interface.goLive(this, item.id, item.type, item.live_status)
            this.getViewCount(i)
            Interface.mFootPrint(i.id,67,this.contentType,1,0,0,0, item.title, this.searchText)
        },
        getViewCount(item) {
            Interface.getData('get', `/course-phase/api/recommend_v2/${item.id}/view`)
        }
    }
}
</script>

<style lang="scss" scoped>
.live-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 0 10px 0;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &-title {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #222222;
        letter-spacing: 0;
        margin-left: 16px;
        font-weight: 500;
        position: relative;
        span {
            position: absolute;
            bottom: 0vw;
            left: 0;
            width: 30px;
            height: 6px;
            background-color: #c7f3e7;
            border-radius: 0.8vw;
            z-index: 1;
        }
    }

    &-box {
        width: 355px;
        height: 72px;
        position: relative;
        padding-bottom: 15px;
        padding-bottom: 0;
    }

    &-left {
        width: 112px;
        height: 66px;
        float: left;
        position: relative;
        border-radius: 6px;
        margin-left: 10px;
        &-img {
            width: 112px;
            height: 66px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            background: #10c3b5;
            border-radius: 6px 3px 3px 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 6px;
            img {
                width: 12px;
                height: 12px;
            }
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            &.current {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
                font-family: PingFangSC-Medium;
                font-size: 10px;
                color: #ffffff;
                letter-spacing: 0;
                img {
                    width: 12px;
                    height: 12px;
                    margin-bottom: -3px;
                }
            }
        }
        &-time {
            width: 100%;
            bottom: 0px;
            position: absolute;
            color: #fff;

            font-family: Avenir-Heavy;
            font-size: 11px;
            letter-spacing: 0;
            text-align: right;

            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
            border-radius: 0 0 6px 6px;

            span {
                display: inline-block;
                margin-bottom: 4px;
                margin-right: 8px;
            }
        }
      &-top{
        position: absolute;
        top: 4px;
        left: 4px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
          width: 18px;
          height: 18px;
          border-radius: 3px;
        }
      }
    }

    &-right {
        float: left;
        margin-left: 10px;
        width: 205px;
        text-align: left;
        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            line-height: 22px;
            font-weight: 500;
            // text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
            .light {
                color: #0fb7ad;
            }
        }
        &-author {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #404040;
            letter-spacing: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
        }
        &-detail {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9d9d9d;
            letter-spacing: 0;

            text-align: left;
            position: absolute;
            bottom: 15px;
            width: 220px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            //overflow: hidden;
            word-break: break-all;
            &-join {
                float: right;
                display: inline-block;
                font-family: PingFangSC-Medium;
                font-size: 13px;
                color: #0CC4B9;
                background: #E6FAF7;
                border-radius: 16.5px;

                padding: 5px 15px;
                margin-top: -10px;
            }
        }
    }

    .live-list-section-left {
        //width: 130px;
        //height: 73px;
        //&-img {
        //    width: 130px;
        //    height: 73px;
        //}
    }
    .live-list-section-right {
        width: 193px;
    }
    .live-list-section-left-zl {
        left: 4px;
        top: 4px;
        border-radius: 3px;
    }
    // .course-list-section-box,
    .live-list-section {
        padding-top: 14px;
        margin-top: 0px;

        // .course-list-section-right-title,
        .live-list-section-right-title {
            padding-right: 14px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
        }
    }
}

.ellipsis-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/lives.vue